import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

import { EVENT_ADDON_ITEM_TYPE } from '../../../../../../../constants/event-items';
import Alert from '../../../../../../../components/global/Alert';
import {
  ALBUM_SUBTYPE,
  ALBUM_UPLOAD_PERMISSIONS,
} from '../../../../../../../constants/albums';
import BoxedCustomControl from '../../../../../../../components/global/BoxedCustomControl';
import CustomControl from '../../../../../../../components/global/CustomControl';
import InfoCircleIcon from '../../../../../../../components/icons/InfoCircleIcon';

const propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  stepProps: PropTypes.object.isRequired,
};

const FreemiumEventCreatePermissionsStep = ({
  values,
  errors,
  handleChange,
  handleBlur,
  stepProps,
}) => {
  const errorList = Object.values(errors);
  const { eventType, includePhotosAlbum } = stepProps;
  const waldofiedAddon = stepProps.eventAddonItems?.find(
    ({ types }) => types[0] === EVENT_ADDON_ITEM_TYPE.MEMORY_BOOK,
  );
  const memoryBookAddon = stepProps.eventAddonItems?.find(
    ({ types }) => types[0] === EVENT_ADDON_ITEM_TYPE.MEMORY_BOOK,
  );
  const groupVideoAddon = stepProps.eventAddonItems?.find(
    ({ types }) => types[0] === EVENT_ADDON_ITEM_TYPE.GROUP_VIDEO,
  );

  const title = (() => {
    if (
      !includePhotosAlbum &&
      stepProps.currentSelectedEventAddonItemIds?.length === 1 &&
      memoryBookAddon &&
      stepProps.currentSelectedEventAddonItemIds.includes(memoryBookAddon.id)
    ) {
      return (
        <>
          Want to collab with others to build your slideshow?
          <br /> Waldo can help!{' '}
          <span
            className="label-tip"
            data-for="tooltip-event-create-permission-step"
            data-tip="Waldo's texting bot will make it easy to gather old photos from others who can simply text them back!"
            data-event="click"
            data-effect="solid"
          >
            <InfoCircleIcon size={20} />

            <ReactTooltip
              id="tooltip-event-create-permission-step"
              className="tooltip"
              globalEventOff="click"
            />
          </span>
        </>
      );
    }

    if (
      waldofiedAddon &&
      stepProps.currentSelectedEventAddonItemIds?.length === 1 &&
      stepProps.currentSelectedEventAddonItemIds.includes(waldofiedAddon.id)
    ) {
      return "Do you want to approve other's photos prior to their being added to your Live Slideshow?";
    }

    if (
      !includePhotosAlbum &&
      stepProps.currentSelectedEventAddonItemIds?.length === 1 &&
      groupVideoAddon &&
      stepProps.currentSelectedEventAddonItemIds.includes(groupVideoAddon.id)
    ) {
      return `May others add videos to the ${
        eventType === ALBUM_SUBTYPE.WEDDINGS ? 'Video Guestbook' : 'Group Video'
      }?`;
    }

    if (
      groupVideoAddon &&
      stepProps.currentSelectedEventAddonItemIds.includes(groupVideoAddon.id)
    ) {
      return 'May others add photos and videos to the albums?';
    }

    return 'May others add photos to the albums?';
  })();

  const requiresReviewLabel = (() => {
    if (
      !includePhotosAlbum &&
      stepProps.currentSelectedEventAddonItemIds?.length === 1 &&
      groupVideoAddon &&
      stepProps.currentSelectedEventAddonItemIds.includes(groupVideoAddon.id)
    ) {
      return 'I want to approve videos prior to being published';
    }

    if (
      groupVideoAddon &&
      stepProps.currentSelectedEventAddonItemIds.includes(groupVideoAddon.id)
    ) {
      return 'I want to approve photos and videos prior to being published';
    }

    return 'I want to approve photos prior to being published';
  })();

  return (
    <Fragment>
      <h2>{title}</h2>
      <BoxedCustomControl
        label="Yes"
        type="checkbox"
        id="permission-yes"
        name="permission"
        onChange={() =>
          handleChange({
            target: {
              name: 'permission',
              value: ALBUM_UPLOAD_PERMISSIONS.ANYONE,
            },
          })
        }
        checked={values.permission === ALBUM_UPLOAD_PERMISSIONS.ANYONE}
        className="mb-2 text-center"
        boxStyle="floating"
      />
      <BoxedCustomControl
        label="No"
        type="checkbox"
        id="permission-no"
        name="permission"
        onChange={() =>
          handleChange({
            target: {
              name: 'permission',
              value: ALBUM_UPLOAD_PERMISSIONS.NONE,
            },
          })
        }
        checked={values.permission === ALBUM_UPLOAD_PERMISSIONS.NONE}
        className="mb-2 text-center"
        boxStyle="floating"
      />
      {values.permission === ALBUM_UPLOAD_PERMISSIONS.ANYONE && (
        <CustomControl
          id="require_review"
          type="checkbox"
          name="require_review"
          label={requiresReviewLabel}
          checked={values.require_review}
          onChange={e => {
            e.stopPropagation();

            handleChange({
              target: {
                name: 'require_review',
                value: !values.require_review,
              },
            });
          }}
          onBlur={handleBlur}
          className="checkbox-require-photo-approval text-sm text-dark align-items-center"
        />
      )}
      {errorList.length > 0 && (
        <Alert type="danger" className="mt-1 text-normal">
          <ul className="mb-0">
            {errorList.map(error => (
              <li key={error}>{error}</li>
            ))}
          </ul>
        </Alert>
      )}
    </Fragment>
  );
};

FreemiumEventCreatePermissionsStep.propTypes = propTypes;

export default FreemiumEventCreatePermissionsStep;
